<!-- 开票订单数据操作 -->
<template>
    <div>
        <el-drawer :close-on-press-escape="true" title="基础信息" :visible.sync="dataActionBox.showStatus" :withHeader="true" :append-to-body="true" custom-class="drawer_box" :wrapperClosable="false" :direction="dataActionBox.openMode"
            size="100%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :isFlag="false" :value="'jciName'" :tabslist="formDataList" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 提取信息 -->
                                <div v-if="scope.index == 0">
                                    <div id="mainInfo">
                                        <el-form label-width="100px" class="baseForm" :model="invoiceExtractData" ref="invoiceExtractData" size="mini" :show-message="false" :disabled="dataActionBox.actionType == 2">
                                            <el-row>

                                                <el-form-item v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <template>
                                                        <!-- 开始时间 -->
                                                        <el-date-picker v-if="formOneValue.entityField == 'start'" size="mini" v-model="invoiceExtractData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                                                            type="date" placeholder="选择日期"></el-date-picker>
                                                        <!-- 结束时间 -->
                                                        <el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini" v-model="invoiceExtractData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
                                                            value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>

                                                        <!-- 开票单位 -->
                                                        <el-tooltip v-else-if="formOneValue.entityField == 'smId'" class="item" :disabled="invoiceExtractData.smName == null || invoiceExtractData.smName.length <= 9" effect="dark"
                                                            :content="invoiceExtractData.smName" placement="bottom-start">
                                                            <el-input clearable v-model="invoiceExtractData.smName" @keyup.enter.native="openSearch(formOneValue.searchId, 0, 'smName', 'smId,smName')">
                                                                <el-button @click="openSearch(formOneValue.searchId, 0, 'smName', 'smId,smName')" slot="append" icon="el-icon-search"></el-button></el-input>
                                                        </el-tooltip>
                                                        <el-input v-else :disabled="formOneValue.isChange == 0" v-model.trim="invoiceExtractData[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    </template>
                                                </el-form-item>
                                                <el-form-item v-if="dataActionBox.actionType != 2">
                                                    <el-button type="primary" size="mini" @click="getExtractBill">选择单据</el-button>
                                                    <el-button type="primary" size="mini" @click="getSearch">选择明细</el-button>
                                                    <el-button type="primary" size="mini" @click="extractBillClick('对账单',1)" v-if="extendShow">提取对账单</el-button>
                                                    <el-button type="primary" size="mini" @click="extractBillClick('费用登记',0)" v-if="extendShow">提取费用登记</el-button>
                                                </el-form-item>
                                                <el-form-item>
                                                    <div v-if="dataActionBox.actionType != 1&&dataActionBox.actionType != 2">
                                                        <input style="display: none;" type="file" id="recordExcel" accept="image/*" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                                        <label for="recordExcel" class="image_label">上传发票</label>
                                                    </div>
                                                    <div>
                                                        <ul class="uploadList" v-if="sendDataInfo.fileUrl">
                                                            <li v-for="(val, key) in sendDataInfo.fileUrl.split(',')" :key="key" class="image">
                                                                <i v-if="dataActionBox.actionType != 1" class="el-icon-error del" @click="delRemove(key)"></i>
                                                                <el-image style="width: 40px; height: 40px;margin-top: 5px;" :src="`${imgUrl}/${val}`" :preview-src-list="sendDataInfo.fileUrl.split(',').map(item => `${imgUrl}/${item}`)">
                                                                </el-image>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </el-form-item>
                                            </el-row>
                                        </el-form>
                                        <!-- 发票信息 -->
                                        <el-form label-width="100px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false" :disabled="dataActionBox.actionType == 2"
                                            style="border-top:1px solid #E4E7ED; padding-top: 10px">
                                            <el-row>
                                                <el-form-item v-for="(formOneValue, formOneKey) in formDataList[1].jurconfigform" v-if="formOneValue.isShow == 1" :key="formOneKey" :label="formOneValue.showField"
                                                    :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- <el-date-picker :editable="true" :disabled="formOneValue.isChange == 0" v-if="formOneValue.fieldType == 'date'" size="mini" v-model="sendDataInfo[formOneValue.entityField]"
                                                       format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker> -->
                                                    <!-- 开票日期 -->
                                                    <df-date :isdisabled="formOneValue.isChange == 0" v-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                                        </el-option>
                                                    </el-select>
                                                    <el-input v-else-if="formOneValue.entityField == 'remark'" type="textarea" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]" maxlength="200">
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'ticketNum'" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                        :maxlength="$store.state.inputLength">
                                                        <template slot="append">
                                                            <span style="color: red;">
                                                                {{ sendDataInfo[formOneValue.entityField] == ''|| sendDataInfo[formOneValue.entityField] == null|| sendDataInfo[formOneValue.entityField] == undefined ? 0: sendDataInfo[formOneValue.entityField].length }}位
                                                            </span>
                                                        </template>
                                                    </el-input>
                                                    <el-input v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                                    </el-input>
                                                </el-form-item>
                                            </el-row>
                                        </el-form>
                                    </div>
                                    <el-row>
                                        <el-col :span="9" style="padding-right:10px">
                                            <!-- 主单据表 -->
                                            <u-table ref="hzTable" :data="sendDataInfo.psdocumentsmasterList" :height="mxHeight" :row-height="30" row-key="index" use-virtual size="mini" :highlight-current-row="false" border
                                                style="width: 100%" @selection-change="mainSelectionChange">
                                                <u-table-column v-if="dataActionBox.actionType != 2" type="selection" width="50" fixed="left"></u-table-column>
                                                <u-table-column label="" prop="" width="50" fixed="left">
                                                    <template slot="header" slot-scope="scope">
                                                        <el-tooltip v-if="dataActionBox.actionType != 2" class="item" effect="dark" content="删除已选中数据" placement="top">
                                                            <i style="font-size: 15px;cursor: pointer;" @click.stop="delInfo" class="el-icon-delete"></i>
                                                        </el-tooltip>
                                                        <span v-else>序号</span>
                                                    </template>
                                                    <template slot-scope="scope">
                                                        <span>{{ scope.$index + 1 }}</span>
                                                    </template>
                                                </u-table-column>
                                                <u-table-column align="center" v-for="(formOneValue, tableKey) in formDataList[2].jurconfigform" :key="tableKey" :prop="formOneValue.entityField" :label="formOneValue.showField"
                                                    show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                                    <template slot-scope="scope">
                                                        <!-- 系统字段 -->
                                                        <!-- 显示通用名称 -->
                                                        <span v-if="formOneValue.entityField == 'bgmId'"></span>
                                                        <span v-else-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                                                scope.row[formOneValue.entityField] }}</a>
                                                        </span>
                                                        <!-- 生产日期 -->
                                                        <span v-else-if="formOneValue.entityField == 'prodate'">
                                                            <span v-if="sendDataInfo.psdocumentsmasterList[scope.$index][formOneValue.entityField]">
                                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                            </span>
                                                        </span>

                                                        <!-- 有效期 -->
                                                        <span v-else-if="formOneValue.entityField == 'expidate'">
                                                            <span v-if="sendDataInfo.psdocumentsmasterList[scope.$index][formOneValue.entityField]">
                                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                            </span>
                                                        </span>

                                                        <!-- 购进单位 -->
                                                        <span v-else-if="formOneValue.entityField == 'smId'">{{
                                             sendDataInfo.psdocumentsmasterList[scope.$index].smName }}</span>
                                                        <!-- 业务员 -->
                                                        <span v-else-if="formOneValue.entityField == 'opmId'">{{
                                             sendDataInfo.psdocumentsmasterList[scope.$index].opmName }}</span>

                                                        <!-- 总金额 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'totalMoney'" type="number" v-model="sendDataInfo.psdocumentsmasterList[scope.$index][formOneValue.entityField]"
                                                            @input="calculationAllData" :disabled="dataActionBox.actionType == 2"></el-input>

                                                        <!-- 税额 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'taxMoney'" type="number" v-model="sendDataInfo.psdocumentsmasterList[scope.$index][formOneValue.entityField]"
                                                            @input="calculationAllData" :disabled="dataActionBox.actionType == 2"></el-input>

                                                        <!-- 含税金额 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'totalPsmoney'" type="number" v-model="sendDataInfo.psdocumentsmasterList[scope.$index][formOneValue.entityField]"
                                                            @input="calculationAllData" :disabled="dataActionBox.actionType == 2"></el-input>
                                                        <span v-else>{{
                                             sendDataInfo.psdocumentsmasterList[scope.$index][formOneValue.entityField]
                                          }}</span>
                                                    </template>
                                                </u-table-column>
                                            </u-table>

                                        </el-col>
                                        <el-col :span="15">
                                            <!-- 明细信息  tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))-->
                                            <u-table :data="sendDataInfo.psdocumentsdetailList" :height="mxHeight" :row-height="30" row-key="index" use-virtual size="mini" :highlight-current-row="false" border style="width: 100%"
                                                :row-style="rowStyle">
                                                <u-table-column type="index" width="50" fixed="left"></u-table-column>
                                                <u-table-column label="选项" v-if="dataActionBox.actionType != 2" width="60" fixed="left">
                                                    <template slot="header" slot-scope="scope">
                                                        <div class="checkbox" style="display: flex;justify-content: space-around;text-align: center;height: 20px;margin-top: 8px;">
                                                            <div>
                                                                <input class="checkbox_input" type="checkbox" :disabled="dataActionBox.actionType != 2 && sendDataInfo.psdocumentsdetailList.length > 0 ? false : true" @click="checkAll"
                                                                    v-model="checked" />
                                                                <el-tooltip class="item" effect="dark" content="删除未选中明细" placement="top">
                                                                    <i style="font-size: 15px;cursor: pointer;" @click.stop="delMxInfo" class="el-icon-delete"></i>
                                                                </el-tooltip>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template slot-scope="scope">
                                                        <input class="checkbox_input" type="checkbox" @change="detailSelectionChange" v-model="detailSelectList" :value="scope.row" />
                                                    </template>
                                                </u-table-column>
                                                <u-table-column align="center" v-for="(formOneValue, tableKey) in formDataList[3].jurconfigform" :key="tableKey" :prop="formOneValue.entityField" :label="formOneValue.showField"
                                                    show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                                    <template slot="header" slot-scope="scope">
                                                        <el-input class="header" v-if="formOneValue.entityField == 'businessId'" v-model.trim="searchObj.businessId" size="mini" :placeholder="`输入${formOneValue.showField}搜索`"
                                                            @keyup.enter.native="getData" />
                                                        <el-input class="header" v-else-if="formOneValue.entityField == 'bgmCode'" v-model.trim="searchObj.bgmCode" size="mini" :placeholder="`输入${formOneValue.showField}搜索`"
                                                            @keyup.enter.native="getData" />
                                                        <el-input class="header" v-else-if="formOneValue.entityField == 'bgmName'" v-model.trim="searchObj.bgmName" size="mini" :placeholder="`输入${formOneValue.showField}搜索`"
                                                            @keyup.enter.native="getData" />
                                                        <el-input class="header" v-else-if="formOneValue.entityField == 'spec'" v-model.trim="searchObj.spec" size="mini" :placeholder="`输入${formOneValue.showField}搜索`"
                                                            @keyup.enter.native="getData" />
                                                        <span v-else>{{ formOneValue.showField }}</span>
                                                    </template>

                                                    <template slot-scope="scope">
                                                        <!-- 生产日期 -->
                                                        <span v-if="formOneValue.entityField == 'prodate'">
                                                            <span v-if="sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                                {{
                                                   $common.getLocalTime(sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField])
                                                }}
                                                            </span>
                                                        </span>
                                                        <span v-else-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                                                scope.row[formOneValue.entityField] }}</a>
                                                        </span>
                                                        <!-- 有效期 -->
                                                        <span v-else-if="formOneValue.entityField == 'expidate'">
                                                            <span v-if="sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                                {{
                                                   $common.getLocalTime(sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField])
                                                }}
                                                            </span>
                                                        </span>

                                                        <!-- 开票数量 -->

                                                        <input class="kaipiao_num " v-else-if="formOneValue.entityField == 'ddinCount'" @input="calculatePrice(1, scope.$index)" @blur="calculatePrice(-1, scope.$index)" type="number"
                                                            v-model.number="sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]"
                                                            :min="sendDataInfo.psdocumentsdetailList[scope.$index].ddinCount < 0 ? sendDataInfo.psdocumentsdetailList[scope.$index].treatCount : 0"
                                                            :max="sendDataInfo.psdocumentsdetailList[scope.$index].ddinCount < 0 ? 0 : sendDataInfo.psdocumentsdetailList[scope.$index].treatCount" :disabled="dataActionBox.actionType == 2">

                                                        <!-- 总金额 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'money'" type="number" :disabled="dataActionBox.actionType == 2"
                                                            v-model="sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- @change="calculatePrice(3,scope.$index)" -->

                                                        <!-- 含税金额 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'psmoney'" type="number" :disabled="dataActionBox.actionType == 2"
                                                            v-model="sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- @change="calculatePrice(4,scope.$index)" -->
                                                        <!-- 税率 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'inRate' && formOneValue.isChange == 1" type="number" :disabled="dataActionBox.actionType == 2"
                                                            v-model="sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 税额 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'taxMoney'" type="number" :disabled="dataActionBox.actionType == 2"
                                                            v-model="sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                        </el-input>

                                                        <!-- 备注 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'remark'" v-model.trim="sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                        </el-input>

                                                        <span v-else>{{
                                             sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]
                                          }}</span>
                                                    </template>
                                                </u-table-column>
                                            </u-table>

                                        </el-col>
                                    </el-row>
                                </div>
                                <!-- 明细信息 -->
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div style="text-align: center;" v-if="formDataList[4]">
                        <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                            <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in formDataList[4].jurconfigform" :key="itemK">
                                <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="margin-top: 10px;text-align: center;">
                        <el-button type="primary" @click="initActionBox('sendDataInfo', 'invoiceExtractData')">取消
                        </el-button>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo', 'invoiceExtractData')" v-if="dataActionBox.actionType != 2">保存</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>

        <!-- 检索方案 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 提取方案 -->
        <el-dialog top="1vh" title="提取采购表单" v-if="DialogExtract" :visible.sync="DialogExtract" width="100%">
            <PurchaseInvoiceExtract ref="invoiceExtract" :invoiceExtractData="invoiceExtractData" :formShow="true" @invoiceExtractMethods="getExData" />
        </el-dialog>
        <!-- 提取方案 -->
        <el-dialog top="1vh" :title="`提取${extractType}`" v-if="extractShow" :visible.sync="extractShow" width="100%">
            <PurchaseInvoice v-if="extractType == '对账单'" ref="PurchaseInvoice" :invoiceExtractData="invoiceExtractData" :formShow="true" @invoiceExtractMethods="getExData" />
            <feeRegistration v-if="extractType == '费用登记'" ref="feeRegistration" :invoiceExtractData="invoiceExtractData" :formShow="true" @invoiceExtractMethods="getExData"></feeRegistration>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import PurchaseInvoiceExtract from '../byComponents/PurchaseInvoiceExtract'
import PurchaseInvoice from '@/components/PurchaseInvoice.vue'
import feeRegistration from '@/components/feeRegistration.vue'

export default {
    name: 'purchaseInvoiceActive',
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: {
        PurchaseInvoiceExtract,
        PurchaseInvoice,
        feeRegistration
    },
    data() {
        //这里存放数据
        return {
            imgUrl: "",
            requesUrl: "",
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            invoiceExtractData: {
                smId: '', //开票单位
                smName: '', //开票单位
                start: '',
                end: '',
                coName: '',
                coId: "",
                businessId: "",
            },
            sendDataInfo: {
                invoicingTime: '', //开票日期
                receiveTime: '',
                psdocumentsdetailList: [],
                psdocumentsmasterList: [],
                railNum: "", //轨号
                remark: "", //备注
                ticketNum: "", //发票号
                poolMoney: 0, //总额合计
                capMoeny: '', //价税合计(大写)
                poolPsmoney: 0, //价税合计 含税总额合计(小写)
                poolTaxmoney: 0, //税额合计
                billType: "",
                fileUrl: "",
            },
            detailSelectList: [], //明细选择数据
            showTabs: '',
            formDataList: [],
            selectedDetailsIndex: 0,
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            DialogExtract: false, //提取
            smId: '',
            seWidth: '0',
            mxHeight: 400, //动态表格高度
            sField: '',
            parentSearchData: {},
            inputel: [],
            checked: false,
            mergeCode: "",
            searchObj: {
                businessId: "",//明细搜索 //业务单号
                bgmCode: "",//明细搜索 //产品编号
                bgmName: "",//明细搜索 //商品名称
                spec: "",//明细搜索 //规格
            },
            detailsList: [],
            loading: false,
            selectData: [],
            //-------------------
            invoiceType: 0, //0对账单，1费用登记，
            extractType: "",
            extractShow: false,
            selectedDataIndexList: [],
            isInvoice: false,
            extendShow: false,
            //----------------------------
            seType: "选择明细",

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'searchObj': {
            handler: function (newValue, oldValue) {
                if (this.searchObj.businessId == "" && this.searchObj.bgmCode == "" && this.searchObj.bgmName == "" && this.searchObj.spec == "") {
                    this.getData()
                }
            },
            deep: true
        },

        //监听列表选中的数据
        detailSelectList() {
            if (this.sendDataInfo.psdocumentsdetailList.length > 0) {
                if (this.detailSelectList.length == this.sendDataInfo.psdocumentsdetailList.length) {
                    this.checked = true; //全选
                } else {
                    this.checked = false; //取消全选
                }
            }
        },
        "invoiceExtractData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.newInit()
                }
            },
            deep: true,
        },
        "invoiceExtractData.coName": {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.invoiceExtractData.coId = ''
                }
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        extractBillClick(type, isInvoice) {
            this.extractType = type
            this.invoiceType = isInvoice
            this.extractShow = true
        },
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {}
            var arr = this.detailSelectList.filter(item => item.dapdId == row.dapdId)
            if (arr.length != 0) {
                rowBackground.backgroundColor = "#c8ffad"
            }
            return rowBackground
        },
        //排序 
        sortArray() {
            // 使用JavaScript的sort方法对数组进行升序排序
            // this.sendDataInfo.psdocumentsdetailList.sort((a, b) => a.createTime - b.createTime);
        },
        getData() {
            var arr = []
            this.detailsList.forEach((item) => {
                var arr1 = this.sendDataInfo.psdocumentsdetailList.filter(val => val.dapdId == item.dapdId)
                if (arr1.length > 0) {
                    item = arr1[0]
                }
                if (!this.searchObj.businessId && !this.searchObj.bgmCode && !this.searchObj.bgmName && !this.searchObj.spec) {
                    arr.push(item)
                } else if ((this.searchObj.businessId == "" || item.businessId === this.searchObj.businessId) && (this.searchObj.bgmCode == "" || item.bgmCode === this.searchObj.bgmCode) && item.bgmName.indexOf(this.searchObj.bgmName) != -1 && item.spec.indexOf(this.searchObj.spec) != -1) {
                    arr.push(item)
                }
            });
            this.sendDataInfo.psdocumentsdetailList = arr
            this.sortArray()
        },
        delRemove(key) {
            var list = []
            if (this.sendDataInfo.fileUrl) {
                list = this.sendDataInfo.fileUrl.split(',')
                list.splice(key, 1)
            }
            this.sendDataInfo.fileUrl = list.join()
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                console.log(files[index]);
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadimgUploadPath(params, true)
                console.log(response.result);
                if (response.status == 200) {
                    var list = []
                    if (this.sendDataInfo.fileUrl) {
                        list = this.sendDataInfo.fileUrl.split(',')
                        list.push(response.result)
                    } else {
                        list.push(response.result)
                    }
                    this.sendDataInfo.fileUrl = list.join()
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                let pathInfo = parent.getMenuInfo(this.$route.path)
                this.$refs.printPlan.openDia(this.mergeCode, "/printData/psdocument", pathInfo.jurId, null, null, null, null, null)
            } else {
                return
            }
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.invoiceExtractData.end = time;
            }
        },
        checkAll() {
            if (this.checked) {
                this.detailSelectList = [];
            } else {
                if (this.detailSelectList.length == 0) {
                    this.detailSelectList = JSON.parse(JSON.stringify(this.detailsList))
                } else {
                    this.detailsList.forEach((item) => {
                        if (this.detailSelectList.indexOf(item) == -1) {
                            this.detailSelectList.push(item);
                        }
                    });
                }
            }
            this.getData()
            this.calculationMainData() //计算主表单数据
        },
        //明细选择触发
        detailSelectionChange() {
            this.calculationMainData() //计算主表单数据
        },
        // 获取 提取单数据
        async getExData(res) {
            let val = JSON.parse(JSON.stringify(res))
            if (val != "" || val != undefined) {
                if (val.isDetail) {
                    this.isInvoice = true
                } else {
                    this.isInvoice = false
                }
                var arr = []
                console.log(val, 'val.11111111111111');
                this.detailsList.forEach((item) => {
                    let arr1 = this.detailSelectList.filter((v) => {
                        return v.dapdId == item.dapdId
                    })
                    if (arr1.length > 0) {
                        arr.push(...arr1)
                    }
                });
                val.mainData.forEach(v => {
                    if (this.sendDataInfo.psdocumentsmasterList.length > 0) {
                        var arr = []
                        if (v.isDetail !== 0) {
                            arr = this.sendDataInfo.psdocumentsmasterList.filter(item => v.dapmId == item.dapmId)
                        } else {
                            arr = this.sendDataInfo.psdocumentsmasterList.filter(item => v.businessId == item.businessId)
                        }
                        if (arr.length <= 0) {
                            this.sendDataInfo.psdocumentsmasterList.push(v)
                        }
                    } else {
                        this.sendDataInfo.psdocumentsmasterList.push(v)
                    }
                })
                val.detailData.forEach((v) => {
                    if (this.detailsList.length > 0) {
                        var arr = this.detailsList.filter(item => item.dapdId == v.dapdId)
                        if (arr.length <= 0) {
                            this.detailsList.push(JSON.parse(JSON.stringify(v)))
                        }
                    } else {
                        this.detailsList.push(JSON.parse(JSON.stringify(v)))
                    }
                })
                console.log(this.detailsList, 'this.detailsList1111111');
                this.getUnique()
                this.detailSelectList = []
                this.detailsList.forEach((item) => {
                    this.$set(item, 'taxMoney', this.$common.getDecimalInfo(3, NP.minus(item.psmoney, item.money)))
                    item.psmoney = parseFloat(item.psmoney)
                    item.money = parseFloat(item.money)
                    let arr1 = this.detailSelectList.filter((v) => {
                        return v.dapdId == item.dapdId
                    })
                    let arr2 = arr.filter((v) => {
                        return v.dapdId == item.dapdId
                    })
                    if (arr1.length == 0 && arr2.length == 0) {
                        this.detailSelectList.push(item);
                    }
                });
                this.sendDataInfo.psdocumentsdetailList = this.detailsList
                this.sortArray()
                this.calculationMainData() //计算主表单数据
            }
            this.extractShow = false
            this.DialogExtract = false
        },
        toDetail(orderId) {
            this.$parent.toDetail(orderId);
        },
        mainSelectionChange(val) {
            this.selectData = val
        },
        delInfo() {
            this.selectData.forEach(item => {
                // 删除主信息
                let index = -1;
                if (item.isDetail !== 0) {
                    index = this.sendDataInfo.psdocumentsmasterList.findIndex(items => items.dapmId == item.dapmId);
                    if (index !== -1) {
                        this.sendDataInfo.psdocumentsmasterList.splice(index, 1);
                    }
                    // 删除所有对应明细
                    this.sendDataInfo.psdocumentsdetailList = this.sendDataInfo.psdocumentsdetailList.filter(detail => detail.dapmId !== item.dapmId);
                    this.detailSelectList = this.detailSelectList.filter(detail => detail.dapmId !== item.dapmId);
                    this.detailsList = this.detailsList.filter(detail => detail.dapmId !== item.dapmId);
                } else {
                    index = this.sendDataInfo.psdocumentsmasterList.findIndex(items => items.businessId == item.businessId);
                    if (index !== -1) {
                        this.sendDataInfo.psdocumentsmasterList.splice(index, 1);
                    }
                }
            });
            this.$refs['hzTable'].clearSelection()
        },
        delMxInfo() {
            if (this.detailsList.length == this.detailSelectList.length) return
            this.detailsList = JSON.parse(JSON.stringify(this.detailSelectList))
            this.sendDataInfo.psdocumentsmasterList = this.sendDataInfo.psdocumentsmasterList.filter(item => {
                if (item.isDetail !== 0) {
                    const index = this.detailsList.findIndex(items => items.dapmId == item.dapmId)
                    if (index != -1) {
                        return true
                    } else {
                        return false
                    }
                }
            })
            this.checked = true
            this.getData()
            this.$forceUpdate()
        },
        //获取提取单据
        getExtractBill() {
            if (this.invoiceExtractData.smId == '') {
                this.$message({
                    message: '请先选择单位',
                    type: 'error'
                })
                return false;
            }
            if (!this.invoiceExtractData.start || !this.invoiceExtractData.end) {
                this.$message({
                    message: '请填写日期',
                    type: 'error'
                })
                return false;
            }
            this.invoiceExtractData.coName = ''
            this.DialogExtract = true;
        },
        //选择明细
        getSearch() {
            this.parentSearchData = {}
            if (this.invoiceExtractData.smId == '') {
                this.$message({
                    message: '请先选择单位',
                    type: 'error'
                })
                return false;
            }
            if (!this.invoiceExtractData.start || !this.invoiceExtractData.end) {
                this.$message({
                    message: '请填写日期',
                    type: 'error'
                })
                return false;
            }
            this.invoiceExtractData.coName = ''
            this.parentSearchData = {
                smId: this.invoiceExtractData.smId,
                start: this.invoiceExtractData.start,
                end: this.invoiceExtractData.end,
            }
            this.seId = 20873997127701
            this.seType = "选择明细"
            this.DialogVisible = true;
        },

        //去重
        getUnique() {
            const map = new Map();
            this.detailsList = this.detailsList.filter(v => !map.has(v.dapdId) && map.set(v.dapdId, 1));
            let map1 = new Map()
            this.sendDataInfo.psdocumentsmasterList = this.sendDataInfo.psdocumentsmasterList.filter(v => !map1.has(v.businessId) && map1.set(v.businessId, 1));
            this.sendDataInfo.psdocumentsdetailList = this.detailsList
            this.sortArray()
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split('<br/>')
            let newArr = []
            const h = this.$createElement
            for (const i in txtArr) {
                newArr.push(h('p', null, txtArr[i]))
            }
            this.$alert(h('div', null, newArr), '提示', {
                confirmButtonText: '确定',
                callback: action => { }
            })
        },

        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seType = ""
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.invoiceExtractData[type]
        },
        //检索带回数据
        changeInputModel(val) {
            console.log('检回', val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == "选择明细") {
                    if (Array.isArray(val)) {
                        var arr = []
                        this.detailsList.forEach((item) => {
                            let arr1 = this.detailSelectList.filter((v) => {
                                return v.dapdId == item.dapdId
                            })
                            if (arr1.length > 0) {
                                arr.push(...arr1)
                            }
                        });
                        const dapmIdMap = new Map()
                        val.forEach(v => {
                            if (v.dapmId && !dapmIdMap.has(v.dapmId)) {
                                dapmIdMap.set(v.dapmId, v)
                            }
                        })
                        dapmIdMap.forEach((v) => {
                            if (this.sendDataInfo.psdocumentsmasterList.length > 0) {
                                var arr = this.sendDataInfo.psdocumentsmasterList.filter(item => v.dapmId == item.dapmId)
                                if (arr.length <= 0) {
                                    this.sendDataInfo.psdocumentsmasterList.push({
                                        dapmId: v.dapmId,
                                        businessId: v.businessId,
                                        smId: v.smId,
                                        smName: v.smName,
                                        opmId: v.opmId,
                                        opmName: v.opmName,
                                        totalMoney: 0,
                                        oldMoney: 0,
                                        totalPsmoney: 0,
                                        taxMoney: 0,
                                        isDetail: 1,
                                        businessType: v.businessType,
                                    })
                                }
                            } else {
                                this.sendDataInfo.psdocumentsmasterList.push({
                                    dapmId: v.dapmId,
                                    businessId: v.businessId,
                                    smId: v.smId,
                                    smName: v.smName,
                                    opmName: v.opmName,
                                    opmId: v.opmId,
                                    totalMoney: 0,
                                    oldMoney: 0,
                                    totalPsmoney: 0,
                                    taxMoney: 0,
                                    isDetail: 1,
                                    businessType: v.businessType,
                                })
                            }
                        })
                        val.forEach(v => {
                            if (this.detailsList.length > 0) {
                                var arr = this.detailsList.filter(item => item.dapdId == v.dapdId)
                                if (arr.length <= 0) {
                                    this.detailsList.push(JSON.parse(JSON.stringify(v)))
                                }
                            } else {
                                this.detailsList.push(JSON.parse(JSON.stringify(v)))
                            }
                        })
                        this.getUnique()
                        this.detailSelectList = []
                        this.detailsList.forEach((item) => {
                            this.$set(item, 'taxMoney', this.$common.getDecimalInfo(3, NP.minus(item.psmoney, item.money)))
                            item.psmoney = parseFloat(item.psmoney)
                            item.money = parseFloat(item.money)
                            item.isDetail = 1
                            let arr1 = this.detailSelectList.filter((v) => {
                                return v.dapdId == item.dapdId
                            })
                            let arr2 = arr.filter((v) => {
                                return v.dapdId == item.dapdId
                            })
                            if (arr1.length == 0 && arr2.length == 0) {
                                this.detailSelectList.push(item);
                            }
                        });
                        this.sendDataInfo.psdocumentsdetailList = this.detailsList
                        this.sortArray()
                        this.calculationMainData() //计算主表单数据
                    }
                } else {
                    this.paramValue(val)
                }
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.invoiceExtractData[item] = val[item]
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        //确认新增
        async sendDataAction(formName1, formName2) {
            let flag = false
            this.$refs[formName1].validate((valid) => {
                if (valid) {

                } else {
                    this.$message({
                        message: '请完善发票号 等信息',
                        type: 'error'
                    })
                    flag = true
                    return false;
                }
            })
            if (flag) return false;

            if (this.sendDataInfo.psdocumentsmasterList.length < 1) {
                this.$message({
                    message: '请先提取有效单据',
                    type: 'error'
                });
                return false
            }

            let sendObj = {}
            for (let j = 0; j < this.detailsList.length; j++) {
                const itemvs = this.detailsList[j];
                if (itemvs.ddinCount == 0) {
                    this.$message({
                        message: '请填写合理的开票数量',
                        type: 'error'
                    });
                    this.$set(itemvs, 'ddinCount', 0)
                    return false
                }
            }
            var sendDataInfo1 = JSON.parse(JSON.stringify(this.sendDataInfo))
            sendDataInfo1.psdocumentsdetailList = this.detailsList
            if (this.isInvoice) {
                sendDataInfo1.psdocumentsdetailList.forEach(item => {
                    this.$set(item, 'dapmId', item.dapmId1)
                })
            }
            if (this.invoiceType == 1) {
                sendDataInfo1.psdocumentsdetailList.forEach(item => {
                    this.$set(item, 'dapmId', item.recdId)
                })
            }
            for (const key in sendDataInfo1) {
                if (typeof sendDataInfo1[key] == 'object' || Array.isArray(sendDataInfo1[key])) {
                    if (key == 'psdocumentsdetailList') {
                        sendObj[key] = sendDataInfo1[key].filter((v) => {
                            for (let j = 0; j < this.detailSelectList.length; j++) {
                                const ele = this.detailSelectList[j]
                                if (v.dapdId == ele.dapdId) return v
                            }
                        })
                    } else {
                        sendObj[key] = JSON.parse(JSON.stringify(sendDataInfo1[key]))
                    }
                } else {
                    sendObj[key] = sendDataInfo1[key]
                }
            }
            let arr = JSON.parse(JSON.stringify(sendObj.psdocumentsmasterList))
            let uniqueArr = [...new Set(arr)];//循环后可能会出现多个重复的业务单号，这里去重
            sendObj.psdocumentsmasterList = uniqueArr
            let responseData
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.psdocumentsAdd(sendObj)
            } else {
                responseData = await this.$http.psdocumentsUpdate(sendObj)
            }
            if (responseData.status == 200) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });

                if (window.global_config.invoiceShow) {
                    this.newInit()
                } else {
                    this.init()
                }
                if (this.dataActionBox.actionType == 0) {
                } else {
                    this.dataActionBox.showStatus = false
                    this.$refs[formName1].resetFields()
                    this.$refs[formName2].resetFields()
                }
                this.$parent.getDataList()

            } else {
                let txtArr = responseData.message.split('<br/>')
                let newArr = []
                const h = this.$createElement
                for (const i in txtArr) {
                    newArr.push(h('p', null, txtArr[i]))
                }
                this.$message({
                    message: h('div', null, newArr),
                    type: 'error'
                });
            }
            // this.sendDataInfo.invoicingTime = this.$moment().valueOf()
            this.sendDataInfo.invoicingTime = ""
            this.sendDataInfo.receiveTime = this.$moment().valueOf()
        },

        //明细选择完毕
        detailSelectOver() {
            if (this.detailSelectList.length < 1) {
                this.$message({
                    message: '请先选中明细信息',
                    type: 'error'
                })
                return false
            }
            this.calculationMainData() //计算主表单数据
        },

        //计算主表单数据
        calculationMainData() {
            this.sendDataInfo.psdocumentsmasterList.forEach(item => { //主单
                if (item.isDetail !== 0) {//存在明细的做法
                    let flag = false //有无选中明细标识
                    this.$set(item, 'totalMoney', 0) //总额
                    this.$set(item, 'totalPsmoney', 0) //税总额
                    this.$set(item, 'taxMoney', 0) //税额
                    var detailsList = this.detailsList.filter(ele => ele.dapmId == item.dapmId)
                    if (detailsList.length > 0) {
                        detailsList.forEach(item1 => {
                            var arr = this.detailSelectList.filter(v => v.dapdId == item1.dapdId)
                            if (arr.length > 0) {
                                flag = true
                                item.totalMoney = NP.plus(item.totalMoney, item1.money)
                                item.totalPsmoney = NP.plus(item.totalPsmoney, item1.psmoney)
                                item.taxMoney = NP.plus(item.taxMoney, item1.taxMoney)
                            }
                        })

                    }
                    if (flag) { //主单有明细
                        item.totalMoney = this.$common.getDecimalInfo(3, item.totalMoney) //总额
                        item.totalPsmoney = this.$common.getDecimalInfo(3, item.totalPsmoney) //税额
                        item.taxMoney = this.$common.getDecimalInfo(3, item.taxMoney) //税
                    } else {
                        item.totalMoney = 0
                        item.totalPsmoney = 0
                        item.taxMoney = 0
                    }
                } else {
                    this.$set(item, 'totalMoney', item.totalntaxMoney) //总额
                    this.$set(item, 'totalPsmoney', item.oldMoney) //税总额
                    this.$set(item, 'taxMoney', item.taxMoney) //税额
                }
            })

            if (this.detailsList.length == this.sendDataInfo.psdocumentsdetailList.length) {
                this.sendDataInfo.psdocumentsdetailList = this.detailsList
            } else {
                this.detailsList.forEach(item => {
                    var indexs = this.sendDataInfo.psdocumentsdetailList.findIndex(items => items.dapdId == ele.dapdId)
                    if (indexs != -1) {
                        this.sendDataInfo.psdocumentsdetailList[indexs] = item
                    }
                })
            }
            this.calculationAllData() //计算总价
        },

        // 计算价格
        calculatePrice(num, index) {
            var dataInfo = this.sendDataInfo.psdocumentsdetailList[index]
            var indexs = this.detailsList.findIndex(items => items.dapdId == dataInfo.dapdId)
            // this.detailsList[indexs]=dataInfo
            this.$set(this.detailsList, indexs, dataInfo)
            var info = this.detailsList[indexs]
            if (num == -1 && (dataInfo.ddinCount == '' || dataInfo.ddinCount == '-')) {
                this.$message({
                    message: '开票数量不能为空',
                    type: 'error'
                })
                info.ddinCount = info.treatCount
                this.sendDataInfo.psdocumentsdetailList[index] = this.detailsList[indexs]
                return
            }
            if (dataInfo.ddinCount == '') {
                this.sendDataInfo.psdocumentsdetailList[index] = this.detailsList[indexs]
                return
            }
            if (info.ddinCount < 0) {
                if (info.ddinCount < info.treatCount) {
                    this.$message({
                        message: '开票数量不能小于待开票数量',
                        type: 'error'
                    })
                    info.ddinCount = info.treatCount
                } else if (info.ddinCount > 0) {
                    this.$message({
                        message: '开票数量不能大于 0',
                        type: 'error'
                    })
                    info.ddinCount = info.treatCount
                }
            } else if (info.ddinCount == NaN) {
                this.$message({
                    message: '开票数量不能为空',
                    type: 'error'
                })
                this.detailsList[indexs].ddinCount = 1
                this.sendDataInfo.psdocumentsdetailList[index] = this.detailsList[indexs]
                return
            } else {
                if (info.ddinCount > info.treatCount) {
                    this.$message({
                        message: '开票数量不能大于待开票数量',
                        type: 'error'
                    })
                    info.ddinCount = info.treatCount
                } else if (info.ddinCount < 0) {
                    this.$message({
                        message: '开票数量不能小于 0',
                        type: 'error'
                    })
                    info.ddinCount = info.treatCount
                }
            }
            info.price = parseFloat(info.price) //单价
            info.psprice = parseFloat(info.psprice) //含税单价
            info.money = parseFloat(info.money) //金额
            info.psmoney = parseFloat(info.psmoney) //含税金额
            info.inRate = parseFloat(info.inRate) //税率
            info.ddinCount = parseFloat(info.ddinCount) //开票数量
            this.$set(this.detailsList[indexs], 'taxMoney', 0)
            //   NP.strip(0.09999999999999998); // = 0.1
            //   NP.plus(a, b); //加法 a+b          
            //   NP.minus(a, b);  //减法  a-b       
            //   NP.times(a, b);      //乘法  a*b    
            //   NP.divide(a, b);   //除法  a/b     
            //   NP.round(a, b);      //a代表取整 b代表取几位小数
            //  通过数量计算 计算金额 (单价*数量)--> 含税金额/(税率/100+1)
            //  通过数量计算 计算金额 (单价*数量)--> 含税金额/(税率/100+1)
            let newMoney = NP.divide(info.psmoney, NP.plus(NP.divide(info.inRate, 100), 1))
            //金额=单价*开票数量
            this.detailsList[indexs].money = this.$common.getDecimalInfo(3, NP.times(info.price, info.ddinCount))
            //含税金额=含税价格*数量
            this.detailsList[indexs].psmoney = this.$common.getDecimalInfo(3, NP.times(info.psprice, info.ddinCount))
            // console.log("含税金额:", info.psmoney, "金额:", info.money,"税额:",NP.minus(info.psmoney, info.money));
            // 税额 = 含税金额 - 金额   绝对值
            this.detailsList[indexs].taxMoney = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
            if (this.detailSelectList.length > 0) {
                var arr = this.detailSelectList.filter(item => item.dapdId == info.dapdId)
                if (arr.length > 0) {
                    this.calculationMainData() //计算主表单数据
                }
            }
            this.sendDataInfo.psdocumentsdetailList[index] = this.detailsList[indexs]
        },
        //计算总价
        calculationAllData() { //页脚
            var arr = this.sendDataInfo.psdocumentsmasterList
            this.sendDataInfo.poolMoney = 0
            this.sendDataInfo.poolPsmoney = 0
            this.sendDataInfo.poolTaxmoney = 0
            arr.forEach((v, i) => {
                this.sendDataInfo.poolMoney = NP.plus(this.sendDataInfo.poolMoney, v.totalMoney || 0) //总额合计
                this.sendDataInfo.poolPsmoney = NP.plus(this.sendDataInfo.poolPsmoney, v.totalPsmoney || 0) //价税合计 含税总额合计(小写)
                this.sendDataInfo.poolTaxmoney = NP.plus(this.sendDataInfo.poolTaxmoney, v.taxMoney || 0) //税额合计
            })
            this.sendDataInfo.poolMoney = this.$common.getDecimalInfo(3, this.sendDataInfo.poolMoney)
            this.sendDataInfo.poolPsmoney = this.$common.getDecimalInfo(3, this.sendDataInfo.poolPsmoney)
            this.sendDataInfo.poolTaxmoney = this.$common.getDecimalInfo(3, this.sendDataInfo.poolTaxmoney)
            this.sendDataInfo.capMoeny = this.changeNumMoneyToChinese(this.sendDataInfo.poolPsmoney) //价税合计(大写)
            this.tiao(1)
        },

        //取消
        initActionBox(formName1, formName2) {
            if (this.dataActionBox.actionType == 2) {
                this.dataActionBox.showStatus = false
                this.init()
                this.$refs[formName1].resetFields()
                this.$refs[formName2].resetFields()
            } else {
                this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.dataActionBox.showStatus = false
                    if (this.dataActionBox.actionType == 1) {
                        this.init(true)
                    } else {
                        this.init()
                    }
                    this.$refs[formName1].resetFields()
                    this.$refs[formName2].resetFields()
                }).catch(() => { })
            }
        },

        //初始化
        init(flag) {
            for (const key in this.invoiceExtractData) {
                this.invoiceExtractData[key] = ''
            }
            for (let key in this.sendDataInfo) {
                if (key == 'psdocumentsmasterList' || key == 'psdocumentsdetailList') {
                    this.sendDataInfo[key] = []
                } else {
                    this.sendDataInfo[key] = ''
                }
            }

            this.invoiceExtractData.start = this.$common.getStartTime()
            this.invoiceExtractData.end = this.$common.getEndTime()
            // this.sendDataInfo.invoicingTime = this.$common.getStartTime()
            this.sendDataInfo.invoicingTime = ""
            this.sendDataInfo.receiveTime = this.$moment().valueOf()
            this.checked = false
            this.isInvoice = false
            this.selectedDataIndexList = []
            this.detailsList = []
            this.detailSelectList = []
            if (flag) {
                this.dataActionBox.actionType = 1
            } else {
                this.dataActionBox.actionType = 0
            }
        },
        newInit() {
            this.invoiceExtractData.smName = ''
            this.invoiceExtractData.smId = ''
            for (let key in this.sendDataInfo) {
                if (key == 'psdocumentsmasterList' || key == 'psdocumentsdetailList') {
                    this.sendDataInfo[key] = []
                } else if (key == 'poolMoney' || key == 'poolPsmoney' || key == 'poolTaxmoney') {
                    this.sendDataInfo[key] = 0
                } else if (key == 'capMoeny') {
                    this.sendDataInfo[key] = '零'
                } else if (key == 'ticketNum' || key == 'railNum' || key == 'remark') {
                    this.sendDataInfo[key] = ''
                }
            }
            this.checked = false
            this.detailsList = []
            this.detailSelectList = []
            this.isInvoice = false
            this.selectedDataIndexList = []
        },

        async isShowData(name, value) {
            switch (name) {
                case 'woamSalecus':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.woamSalecus = dataInfo.smId
                        this.sendDataInfo.woamSalecusName = dataInfo.smName

                    }
                    this.sendDataInfo.woamOpposalesman = ''
                    break;
                case 'cargoOwner':
                    var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
                    // console.log(dataInfo)
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                    }
                    break;
                default:
                    this.sendDataInfo[name] = value
            }
        },

        //上级流入
        openBox(cate, formData, oldData = '') {
            this.imgur()
            this.showTabs = formData[0].jciName
            this.formDataList = formData
            this.mergeCode = oldData.mergeCode
            this.extendShow = window.global_config.extendShow || false
            oldData = JSON.parse(JSON.stringify(oldData))
            this.filterMainField()
            if (cate == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'

            } else if (cate == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                this.sendDataInfo = oldData
                this.invoiceExtractData['smId'] = oldData.smId
                this.invoiceExtractData['smName'] = oldData.smName
                this.sendDataInfo.psdocumentsmasterList = []
                this.sendDataInfo.psdocumentsdetailList = []
                this.$set(this.sendDataInfo, 'oldticketNum', oldData.ticketNum)
                this.$set(this.sendDataInfo, 'oldrailNum', oldData.railNum)
                this.$http.psdocumentsQueryDetail({
                    railNum: oldData.railNum,  //	轨号
                    ticketNum: oldData.ticketNum,  //	发票号
                }).then((res) => {
                    if (res.status == 200) {
                        var resData = res.result
                        this.sendDataInfo.psdocumentsmasterList = resData.psdocumentsmasterList
                        this.sendDataInfo.psdocumentsdetailList = resData.psdocumentsdetailList
                        this.detailsList = this.sendDataInfo.psdocumentsdetailList
                        this.detailSelectList = this.sendDataInfo.psdocumentsdetailList
                    }
                })
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                this.dataActionBox.openMode = 'rtl'
                this.sendDataInfo = oldData
                this.invoiceExtractData['smId'] = oldData.smId
                this.invoiceExtractData['smName'] = oldData.smName
                this.sendDataInfo.psdocumentsmasterList = []
                this.sendDataInfo.psdocumentsdetailList = []
                this.$http.psdocumentsQueryDetail({
                    railNum: oldData.railNum,  //	轨号
                    ticketNum: oldData.ticketNum,  //	发票号
                }).then((res) => {
                    if (res.status == 200) {
                        var resData = res.result
                        this.sendDataInfo.psdocumentsmasterList = resData.psdocumentsmasterList
                        this.sendDataInfo.psdocumentsdetailList = resData.psdocumentsdetailList
                        this.detailsList = this.sendDataInfo.psdocumentsdetailList
                    }
                })
            }
            this.tiao()
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true
        },
        findByJciId(list, id) {
            return list.find(item => item.jciId === id) || {};
        },
        // 过滤表单不同类型
        filterMainField() {
            const JCI_IDS = {
                MASTER: 11481,
                DETAIL: 11482
            };
            const FIELD_DEFINITIONS = [
                { entityField: "psdocumentsmasterList" },
                { entityField: "psdocumentsdetailList" }
            ];
            // ===================================
            // 主处理逻辑
            // ===================================
            // 获取提取查询配置项
            const masterRecord = this.findByJciId(this.formDataList, JCI_IDS.MASTER);
            // 获取发票信息配置项
            const detailRecord = this.findByJciId(this.formDataList, JCI_IDS.DETAIL);
            // 执行字段过滤操作
            const filteredMasterData = this.$common.filterMainFields([], FIELD_DEFINITIONS, detailRecord);
            const filteredDetailData = this.$common.filterMainFields([], [], masterRecord);

            // 安全地合并到目标对象中（确保响应式更新）
            Object.keys(filteredMasterData).forEach(key => {
                this.$set(this.sendDataInfo, key, filteredMasterData[key]);
            });

            Object.keys(filteredDetailData).forEach(key => {
                this.$set(this.invoiceExtractData, key, filteredDetailData[key]); // 修正了这里应该用 filteredDetailData
            });

            this.invoiceExtractData.start = this.$common.getStartTime()
            this.invoiceExtractData.end = this.$common.getEndTime()
            // this.sendDataInfo.invoicingTime = this.$common.getStartTime()
            this.sendDataInfo.invoicingTime = ""
            this.sendDataInfo.receiveTime = this.$moment().valueOf()
            this.checked = false
            this.detailsList = []
            this.detailSelectList = []
            this.isInvoice = false
            this.selectedDataIndexList = []
        },
        tiao(val) {
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    if (val != 1) {
                        this.initFocus();
                    }
                }, 16.7)
            })
        },
        //数字转中文大写
        changeNumMoneyToChinese(money) {
            var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
            var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
            var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
            var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
            var cnInteger = "整"; //整数金额时后面跟的字符
            var cnIntLast = "元"; //整型完以后的单位
            var maxNum = 999999999999999.9999; //最大处理的数字
            var IntegerNum; //金额整数部分
            var DecimalNum; //金额小数部分
            var ChineseStr = ""; //输出的中文金额字符串
            var parts; //分离金额后用的数组，预定义    
            var Symbol = ""; //正负值标记
            if (money == "") {
                return "零";
            }
            money = parseFloat(money);
            if (money >= maxNum) {
                alert('超出最大处理数字');
                return "";
            }
            if (money == 0) {
                ChineseStr = cnNums[0] + cnIntLast + cnInteger;
                return ChineseStr;
            }
            if (money < 0) {
                money = -money;
                Symbol = "负 ";
            }
            money = money.toString(); //转换为字符串
            if (money.indexOf(".") == -1) {
                IntegerNum = money;
                DecimalNum = '';
            } else {
                parts = money.split(".");
                IntegerNum = parts[0];
                DecimalNum = parts[1].substr(0, 4);
            }
            if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
                var zeroCount = 0;
                var IntLen = IntegerNum.length;
                for (var i = 0; i < IntLen; i++) {
                    var n = IntegerNum.substr(i, 1);
                    var p = IntLen - i - 1;
                    var q = p / 4;
                    var m = p % 4;
                    if (n == "0") {
                        zeroCount++;
                    } else {
                        if (zeroCount > 0) {
                            ChineseStr += cnNums[0];
                        }
                        zeroCount = 0; //归零
                        ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                    }
                    if (m == 0 && zeroCount < 4) {
                        ChineseStr += cnIntUnits[q];
                    }
                }
                ChineseStr += cnIntLast;
                //整型部分处理完毕
            }
            if (DecimalNum != '') { //小数部分
                var decLen = DecimalNum.length;
                for (var i = 0; i < decLen; i++) {
                    var n = DecimalNum.substr(i, 1);
                    if (n != '0') {
                        ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
                    }
                }
            }
            if (ChineseStr == '') {
                ChineseStr += cnNums[0] + cnIntLast + cnInteger;
            } else if (DecimalNum == '') {
                ChineseStr += cnInteger;
            }
            ChineseStr = Symbol + ChineseStr;

            return ChineseStr;
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        imgur() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    console.log(this.inputel[index])
                    this.inputel[index].focus();
                    break;
                }
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
::v-deep .el-drawer .el-drawer__header {
    height: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
}

.detailForm {
    margin-bottom: 0.2rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
}

.detailForm .el-input {
    width: auto;
}

.table_button_box {
    height: 200px;
    background-color: red;
}

/* .table_content_box {
    height: 500px !important;
    overflow-y: auto;
} */

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.foot {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding: 5px 0;
    z-index: 999;
}

.el-drawer {
    outline: none;
}

.kaipiao_num {
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    height: 28px;
    width: 100%;
    line-height: 40px;
    padding: 0 15px;
    outline: 0;
}

/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    list-style: none;
}

.image {
    position: relative;
    width: 45px;
    height: 45px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
    font-size: 7px;
}

::v-deep .plTableBox .el-table .cell {
    padding: 0 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    height: 30px !important;
    line-height: 30px !important;
}

::v-deep .plTableBox .el-input__inner {
    height: 25px !important;
    line-height: 25px !important;
    padding: 0 3px !important;
    padding-right: 20px !important;
}

.filtrate {
    position: relative;
}

.filtrate :hover {
    color: #409eff !important;
}

::v-deep .has-gutter {
    height: 30px !important;
}

::v-deep .el-table_2_column_9 {
    height: 30px !important;
}

/* ::v-deep .el-table__fixed-body-wrapper{
   top: 37px !important;
} */
</style>